import './less/addToCart.less';

import {FileUploader} from "../../../dev/js/core/Helpers/fileUploader/fileUploader";

import axios from 'axios';

const addToCart = props => {
	let URL = 'add-to-cart.html';
	let errors = [];
	let engravingFile = null;
	let formData = new FormData();
	
	let additionals = [];
	
	let toCart = {
		IDWariantu: document.querySelector('#js-variantId').value,
		Ilosc: document.querySelector('#js-details-quantity').value,
		Uwagi: document.querySelector('#js-additional').value,
		additional: [],
		services: [],
	};
	
	const insertVariant = () => {
		let selects = document.getElementsByClassName('js-variant-select');
		
		[...selects].map(select => {
			select.value === '' ? errors.push({elem: select.dataset.name}) : null;
		});
	};
	
	const insertCustomFile = () => {
		return new Promise(resolve => {
			let files = document.querySelector('#js-custom-files');
			let variant = document.querySelector('#js-custom-file-variant');
			
			if (files && !files.classList.contains('shrunk')) {
				let err = [];
				let input = document.querySelector('#js-custom-file');
				
				if (!input.files.length) {
					err.push({
						elem: input.dataset.name
					});
				}
				
				if (!variant.value) {
					err.push({
						elem: variant.dataset.name
					});
				}
				
				if (!err.length) {
					// upload file
					let fd = new FormData();
					fd.append("customFile", input.files[0]);
					
					axios({
						method: 'post',
						url: 'upload-custom-file.html',
						data: fd,
						config: {headers: {'Content-Type': 'multipart/form-data'}}
					}).then(r => {
						if (r.data.status && r.data.status === 'success') {
							let customFileData = {
								id: r.data.data.ID,
								ext: r.data.data.Ext,
								size: r.data.data.Filesize,
								paths: r.data.data.FilePath,
								links: r.data.data.Link,
								name: r.data.data.Name
							};
							
							resolve({
								IDWariantu: variant.value,
								type: 'customFile',
								TrescGrawerki: JSON.stringify(customFileData),
							});
						}
					});
				}
				
				errors = [...errors, ...err];
			} else {
				resolve([]);
			}
		});
	};
	
	const insertEngravement = () => {
		let engravement = document.querySelector('#js-engravement-additional');
		
		if (engravement && !engravement.classList.contains('shrunk')) {
			let err = [];
			let input = document.querySelector('select.js-engraving-variantId');
			
			let variant = input.value;
			// let engravementContent = CKEDITOR.instances['js-custom-inscription'].getData();
			let engravementContent = document.querySelector('.js-custom-inscription').value;
			/*let fileInput = document.getElementById('engraving');

			let engraving = $('#engraving').length > 0
				? new FileUploader($('#engraving'), false)
				: null;*/
			
			/*engravingFile = engraving !== null ? engraving[0] : null;

			formData.append('engravingFile', engravingFile);*/
			
			if (variant === '') {
				err.push({
					elem: input.dataset.name
				});
			}
			
			if (engravementContent === '' /*&& fileInput.files.length === 0*/) {
				err.push({
					elem: fileInput.dataset.name
				});
			}
			
			err.length < 1
				? toCart.additional.push({
					IDWariantu: input.value,
					type: 'engravement',
					TrescGrawerki: engravementContent,
				})
				: null;
			
			errors = [...errors, ...err];
		}
		
	};
	
	
	const insertEmblems = () => {
		let expandables = document.getElementsByClassName('js-accessories-set');
		let err = [];
		
		[...expandables].map(expandable => {
			
			if (!expandable.classList.contains('shrunk')) {
				let input = expandable.getElementsByClassName('emblemValue')[0];
				
				if (input.value === '') {
					err.push({
						elem: input.dataset.name
					});
				}
				
				err.length < 1
					? toCart.additional.push({
						IDWariantu: expandable.getElementsByClassName('emblemValue')[0].value,
						type: 'emblem'
					})
					: null;
				
				errors = [...errors, ...err];
			}
			
		});
	};
	
	const insertServices = () => {
		let services = document.getElementsByClassName('js-price-compound-clickable');
		
		[...services].map(service => {
			service.classList.contains('js-price-compound')
				? toCart.services.push({ServiceID: parseInt(service.value)})
				: null;
		});
	};
	
	const validateModules = () => {
		return errors.length < 1;
	};
	
	
	const showErrors = () => {
		let container = document.querySelector('#add-to-cart-errors');
		container.innerText = '';
		
		let infoElement = document.createElement('div');
		infoElement.setAttribute('id', 'add-to-cart-errors-info');
		infoElement.innerText = container.dataset.info;
		
		container.appendChild(infoElement);
		
		errors.map(error => container.insertAdjacentHTML('beforeend', `<span class="add-to-cart-error-elem">${error.elem}</span>`));
		
	};
	
	// const clearDesignForms = () => {
	//
	// 	let remove = container.querySelector('.js-remove-designed-product');
	// 	let preview = container.querySelector('.js-designer-preview');
	// 	let input = container.querySelector('.js-custom-inscription');
	// 	let image = container.querySelector('.js-designer-preview-image');
	// 	let designer = document.querySelector('.js-designer');
	// 	let container = document.querySelector('.js-engraving-controls');
	//
	// 	let customDesign = document.querySelector('.filesInput__list__item__remove a');
	//
	// 	if (remove) {
	// 		remove.dataset.svg = '#';
	// 		remove.dataset.png = '#';
	// 	}
	// 	if (preview) {
	// 		preview.href = '#';
	// 	}
	// 	if (input) {
	// 		input.value = '';
	// 	}
	// 	if (image) {
	// 		image.src = '';
	// 		image.classList.add('hidden');
	// 	}
	// 	if (designer) {
	// 		designer.classList.remove('hidden');
	// 	}
	// 	if (container) {
	// 		container.classList.add('hidden');
	// 	}
	// 	if (customDesign) {
	// 		customDesign.closest('.filesInput__list__item').remove();
	// 	}
	// }
	
	const sendCart = () => {
		$('body').append('<div id="js-cart-loader" class="cart-overlay">' +
			'<div class="cart-loader"><span><i class="fa fa-cog fa-spin fa-stack-1x"></i></span></div>' +
			'</div>');
		
		axios({
			method: 'post',
			url: URL,
			data: formData,
			config: {headers: {'Content-Type': 'multipart/form-data'}}
		})
			.then(response => {
				$('#js-cart-loader').remove();
				refreshSmallCart();
				$('body').append(response.data);
				$('#js-barBasketContent').removeClass('empty')
				let link = $('#js-barBasketContent').find('a');
				link.attr('href', link.data('href')).find('.js-cart-count').removeClass('hidden');
				
				// clearDesignForms();
				
			});
	};
	
	
	const refreshSmallCart = () => {
		$.get('pobierz_produkty_ajax.html?' + $.now(), function (response) {
			let data = JSON.parse(response);
			$('.js-cart-count').html(data.currentCount);
		});
	}
	
	
	insertVariant();
	insertEngravement();
	insertEmblems();
	insertServices();
	
	insertCustomFile().then(customFile => {
		if (customFile) {
			toCart.additional.push(customFile);
		}
		
		formData.append('toCart', JSON.stringify(toCart));
		
		validateModules()
			? sendCart()
			: showErrors();
	});
	
	/* 	for (let pair of formData.entries()) {
			console.log('Klucz: ' + pair[0]+ ', ' + pair[1]);
		} */
	
};

export default addToCart;


// WEBPACK FOOTER //
// ./components/productDetails/addToCart.js